module.exports = __webpack_public_path__ + "img/Pan_Maleri-under-Pan-–-den-nyromantiske-helten.2dceef7e.jpg";